import React, { useState, useEffect } from "react";
import Autosuggest from "react-autosuggest";
import styles from "./flight.module.css";
import "./homepage.css";
import { useNavigate } from "react-router-dom";
import data from "./Airports.json";
export const Home = () => {
  const [fromSuggestions, setFromSuggestions] = useState([]);
  const [toSuggestions, setToSuggestions] = useState([]);
  const [airportsData, setAirportsData] = useState([]);
  const [type, setType] = useState("ONE_WAY");
  const [departureDate, setDepartureDate] = useState("");
  const [returnDate, setReturnDate] = useState("");
  const [classOfService, setClassOfService] = useState("ECONOMY");
  const [fareType, setFareType] = useState("REGULAR");
  const [seniors, setSeniors] = useState(0);
  const [selectedButtonColor, setSelectedButtonColor] = useState(1);
  const [selectedButtonColor1, setSelectedButtonColor1] = useState(1);
  const [travellers, setTravellers] = useState(null);
  const arr = [1, 2, 3, 4, 5, 6, 7, 8];
  const ar1 = [0, 1, 2, 3, 4, 5];
  const [openTravellers, setOpenTravellers] = useState(false);
  const [togglePassengerColor, setTogglePassengerColor] = useState(false);
  const navigate = useNavigate();
  const [fromValue, setFromValue] = useState("");
  const [toValue, setToValue] = useState("");
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);

useEffect(() => {
  setAirportsData(data);
}, []);

  const swapValuehandler = () => {
    let temp = fromValue;
    setFromValue(toValue);
    setToValue(temp);
  };

  const fetchSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    const filteredSuggestions = airportsData.filter(
      (airport) =>
        airport.name.toLowerCase().includes(inputValue) ||
        airport.city.toLowerCase().includes(inputValue) ||
        airport.country.toLowerCase().includes(inputValue) ||
        airport.iata_code.toLowerCase().includes(inputValue)
    );
    return filteredSuggestions.slice(0, 5); // Limit the suggestions to 5
  };

  const getSuggestionValue = (suggestion) => suggestion.iata_code;

  const renderSuggestion = (suggestion) => (
    <div className="suggestion-item">
      <div className="suggestion-content">
        <span className="suggestion-name">{suggestion.name}</span>
        <span className="suggestion-details">
          {suggestion.city}, {suggestion.country}, {suggestion.iata_code}
        </span>
      </div>
      <hr className="suggestion-divider" />
    </div>
  );

  const onFromSuggestionsFetchRequested = ({ value }) => {
    setFromSuggestions(fetchSuggestions(value));
  };

  const onToSuggestionsFetchRequested = ({ value }) => {
    setToSuggestions(fetchSuggestions(value));
  };

  const onFromSuggestionsClearRequested = () => {
    setFromSuggestions([]);
  };

  const onToSuggestionsClearRequested = () => {
    setToSuggestions([]);
  };

  const onFromChange = (event, { newValue }) => {
    setFromValue(newValue);
  };

  const onToChange = (event, { newValue }) => {
    setToValue(newValue);
  };

  const fromInputProps = {
    placeholder: "From",
    value: fromValue,
    onChange: onFromChange,
  };

  const toInputProps = {
    placeholder: "To",
    value: toValue,
    onChange: onToChange,
  };

  const renderSuggestionsContainer = ({ containerProps, children }) => (
    <div {...containerProps} className="custom-suggestions-container">
      {children}
    </div>
  );

  const totalTravellers = `${adults} Adult${
    adults > 1 ? "s" : ""
  }, ${children} Child${children > 1 ? "ren" : ""}`;

  const handleClickModal = (e) => {
    setOpenTravellers(!openTravellers);
    e.stopPropagation();
  };

  const handleClickNoOfPass = (val) => {
    setAdults(val);
  };

  const handleClickNoOfPass1 = (val) => {
    setChildren(val);
  };

  const handleSubmit = () => {
    const data = {
      from: fromValue,
      to: toValue,
      type: type,
      departure_date: departureDate,
      class: classOfService,
      adults: adults,
      seniors: children,
    };
    navigate("/FlightSearch", { state: data });
  };

  return (
    <>
      <div className="homeInputBx" id="flightinputBx">
        <div>
          <div className="homeInputs">
            <input
              name="type"
              type="radio"
              id="inputs"
              value="ONE_WAY"
              onChange={(e) => setType(e.target.value)}
            />
            <label htmlFor="inputs">ONE WAY</label>
          </div>
          <div className="homeInputs">
            <input
              name="type"
              type="radio"
              id="inputs2"
              value="ROUND_TRIP"
              onChange={(e) => setType(e.target.value)}
            />
            <label htmlFor="inputs2">ROUND TRIP</label>
          </div>
        </div>
        <p>Book International and Domestic Flights</p>
      </div>

      <div className="homeMainSearchInput" id="homeMainSearchInputc1">
        <div className="MainSearchinputBx">
          <span>FROM</span>
          <Autosuggest
            suggestions={fromSuggestions}
            onSuggestionsFetchRequested={onFromSuggestionsFetchRequested}
            onSuggestionsClearRequested={onFromSuggestionsClearRequested}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            renderSuggestionsContainer={renderSuggestionsContainer}
            inputProps={fromInputProps}
            id="from"
          />
          <button onClick={swapValuehandler}>
            <i className="fa fa-exchange"></i>
          </button>
        </div>

        <div className="MainSearchinputBx">
          <span>TO</span>
          <Autosuggest
            suggestions={toSuggestions}
            onSuggestionsFetchRequested={onToSuggestionsFetchRequested}
            onSuggestionsClearRequested={onToSuggestionsClearRequested}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            renderSuggestionsContainer={renderSuggestionsContainer}
            inputProps={toInputProps}
            id="fromTo"
          />
        </div>
        <div className="MainSearchinputBx">
          <span>DEPARTURE</span>
          <input
            type="date"
            value={departureDate}
            onChange={(e) => setDepartureDate(e.target.value)}
          />
        </div>
        {/* <div className="MainSearchinputBx">
          <span>RETURN</span>
          <input
            type="date"
            value={returnDate}
            onChange={(e) => setReturnDate(e.target.value)}
          /> 
        </div> */}
        <div>
          <div>
            <div className={styles.travellerContainer}>
              <div onClick={handleClickModal}>
                <div className={styles.travellersText}>TRAVELLERS</div>
                <div
                  className={styles.noOfTraveller}
                  style={{ marginTop: "-6px" }}
                >
                  {totalTravellers}
                </div>
              </div>

              <div
                className={
                  openTravellers ? styles.traveller_modal : styles.noDisplay
                }
              >
                {/* For Adults */}
                <div className={styles.adultChild}>ADULTS (12y +)</div>
                <div className={styles.passengerButtonContainer}>
                  {arr.map((val) => (
                    <div
                      key={val}
                      className={`${
                        selectedButtonColor === val
                          ? styles.clickPassenger
                          : styles.passengerButton
                      }`}
                      onClick={() => {
                        setTogglePassengerColor(!togglePassengerColor);
                        handleClickNoOfPass(val);
                        setSelectedButtonColor(val);
                      }}
                    >
                      {val}
                    </div>
                  ))}
                </div>

                {/* For Children */}
                <div className={styles.adultChild}>CHILDREN (2y - 12y )</div>
                <div className={styles.passengerButtonContainer}>
                  {ar1.map((val) => (
                    <div
                      key={val}
                      className={`${
                        selectedButtonColor1 === val
                          ? styles.clickPassenger
                          : styles.passengerButton
                      }`}
                      onClick={() => {
                        setTogglePassengerColor(!togglePassengerColor);
                        handleClickNoOfPass1(val);
                        setSelectedButtonColor1(val);
                      }}
                    >
                      {val}
                    </div>
                  ))}
                </div>

                <div
                  className={styles.modalApplyText}
                  onClick={handleClickModal}
                >
                  <div>Apply</div>
                </div>
              </div>
            </div>
          </div>

          <select
            className="homeSelect"
            onChange={(e) => setClassOfService(e.target.value)}
          >
            <option value="ECONOMY">Economy</option>
            <option value="PREMIUM_ECONOMY">Premium Economy</option>
            <option value="BUSINESS">Business</option>
            <option value="FIRST">First</option>
          </select>
        </div>
      </div>

      <div className="Homeoptions" id="Homeoptions">
        <h3>
          Select A <br /> Fare Type:
        </h3>
        <div className="optionsInputBx">
          <input type="radio" name="fares" />
          <p>Regular Fares</p>
        </div>
        <div className="optionsInputBx">
          <input type="radio" name="fares" />
          <p>Armed Forces Fares</p>
        </div>
        <div className="optionsInputBx">
          <input type="radio" name="fares" />
          <p>Student Fares</p>
        </div>
        <div className="optionsInputBx">
          <input type="radio" name="fares" />
          <p>Senior Citizen Fares</p>
        </div>
        <div className="optionsInputBx">
          <input type="radio" name="fares" />
          <p>Doctor & Nurse Fares</p>
        </div>
        <div className="optionsInputBx">
          <input disabled type="radio" name="fares" />
          <p>Double Seat fares</p>
        </div>
      </div>
      <div className="homeSearchButtonBx">
        <button onClick={() => handleSubmit()}>Search</button>
      </div>
    </>
  );
};

export default Home;
